import * as actionTypes from './actionTypes';
import axios from 'axios';
import {push} from "react-router-redux";
import {errorEvent} from "../../utils/axiosErrors";
import {MODAL_ARCHIVE_PATIENT_HIDE} from "./actionTypes";
import {admissionListReload} from "./admissionList";

export const load = (id) => {
    return (dispatch, getState) => {
        console.log('[actions/Admission] load', id);
        dispatch({type: actionTypes.LOADING_START});
        const idToken = getState().auth.idToken;

        console.log('[action/admissions] fetchData', id);

        axios.get(
            `/admission/${id}`,
            {headers: {'Authorization': idToken}}
        )
            .then((response) => {
                console.log('[action/admissions] response', response.data);
                dispatch({type: actionTypes.ADMISSION_SET, admission: response.data.admission});
                dispatch({type: actionTypes.LOADING_DONE});
                dispatch({type: actionTypes.AUTH_SELECT_HOSPITAL, ...response.data.admission.hospital});
            })
            .catch((error) => {
                dispatch(errorEvent(error, `/admission/${id}`));
            })
        ;

    }
}

export const sendMessage = (admission, addToast, title, text, smsNotification, smsText, vars = {}, customUI = null) => {
    return (dispatch, getState) => {
        console.log('[action/admissions] sendMessage', admission.id);
        const idToken = getState().auth.idToken;
        // dispatch({type: actionTypes.SEND_MESSAGE_START, id: admission.id});
        dispatch({type: actionTypes.RELOADING_PROGRESS_START, id: admission.id});

        axios.post(
            `/admission/${admission.id}/send-message`,
            {title, text, smsNotification, smsText, vars, customUI: customUI ? customUI.id : null},
            {headers: {'Authorization': idToken}}
        )
            .then((response) => {
                console.log('[action/admissions] sendMessage response', response.data);
                // dispatch({type: actionTypes.ADMISSION_SET, admission: response.data.admission});
                // dispatch({type: actionTypes.LOADING_DONE});
                dispatch({type: actionTypes.RELOADING_PROGRESS_DONE, id: admission.id});

                if (response.data.done) {
                    addToast(`Message sent for ${admission.label}`, {
                        appearance: 'success',
                        autoDismiss: false
                    });
                    const currentAdmission = getState().admission.admission;
                    if (currentAdmission && (currentAdmission.id === admission.id)) {
                        console.log('[action/admissions] sendMessage fast reload');
                        dispatch({type: actionTypes.ADMISSION_SET, admission: response.data.admission});
                    }
                    dispatch({type: actionTypes.ADMISSION_UPDATE, admission: response.data.admission});
                } else {
                    addToast(`Failed to send message for admission ${admission.label} - got exception ${response.data.customStatus}`, {
                        appearance: 'error',
                        autoDismiss: false
                    });
                }
            });
    }
}
export const addAdmission = (data, errorCallback) => {
    return (dispatch, getState) => {
        console.log('[action/admission] addAdmission', data);
        const idToken = getState().auth.idToken;
        dispatch({type: actionTypes.LOADING_START});

        axios.post(
            `/admission/add`,
            data,
            {headers: {'Authorization': idToken}}
        )
            .then((response) => {
                console.log('[action/admission] addAdmission response', response.data);
                // dispatch({type: actionTypes.ADMISSION_SET, admission: response.data.admission});
                // dispatch({type: actionTypes.LOADING_DONE});
                if (response.data.done) {
                    dispatch(push(`/admission/${response.data.id}`))
                } else {
                    errorCallback(response.data.customStatus);
                    dispatch({type: actionTypes.LOADING_DONE});
                }
            });
    }
}

export const resendSms = (admission, addToast) => {
    return (dispatch, getState) => {
        console.log('[action/admissions] resendSms', admission.id);
        const idToken = getState().auth.idToken;
        dispatch({type: actionTypes.RESEND_SMS_START, id: admission.id});
        dispatch({type: actionTypes.MODAL_RESEND_SMS_HIDE});

        axios.get(
            `/admission/${admission.id}/resend-sms`,
            {headers: {'Authorization': idToken}}
        )
            .then((response) => {
                console.log('[action/admissions] resendSms response', response.data);
                // dispatch({type: actionTypes.ADMISSION_SET, admission: response.data.admission});
                // dispatch({type: actionTypes.LOADING_DONE});
                if (response.data.done) {
                    addToast(`Sms resent for admission ${admission.label}`, {
                        appearance: 'success',
                        autoDismiss: false
                    });
                    dispatch({type: actionTypes.RESEND_SMS_DONE, id: admission.id});
                    const currentAdmission = getState().admission.admission;
                    if (currentAdmission && (currentAdmission.id === admission.id)) {
                        console.log('[action/admissions] resendSms fast reload');
                        dispatch({type: actionTypes.ADMISSION_SET, admission: response.data.admission});
                    }
                    dispatch({type: actionTypes.ADMISSION_UPDATE, admission: response.data.admission});
                } else {
                    addToast(`Failed to resend sms for admission ${admission.label}`, {
                        appearance: 'error',
                        autoDismiss: false
                    });
                    dispatch({type: actionTypes.RESEND_SMS_DONE, id: admission.id});
                }
            });
    }
}

export const archiveAdmissionDocuments = (admission, addToast) => {
    return (dispatch, getState) => {
        console.log('[action/admissions] archiveAdmissionDocuments', admission.id);
        const idToken = getState().auth.idToken;
        dispatch({type: actionTypes.ARCHIVE_ADMISSION_DOCUMENTS_START, id: admission.id});
        dispatch({type: actionTypes.MODAL_ARCHIVE_ADMISSION_DOCUMENTS_HIDE});

        axios.get(
            `/admission/${admission.id}/archive-admission-documents`,
            {headers: {'Authorization': idToken}}
        )
            .then((response) => {
                console.log('[action/admissions] archiveAdmissionDocuments response', response.data);
                // dispatch({type: actionTypes.ADMISSION_SET, admission: response.data.admission});
                // dispatch({type: actionTypes.LOADING_DONE});
                if (response.data.done) {
                    addToast(`Admission Documents Archived for admission ${admission.label}`, {
                        appearance: 'success',
                        autoDismiss: false
                    });
                    dispatch({type: actionTypes.ARCHIVE_ADMISSION_DOCUMENTS_DONE, id: admission.id});
                    const currentAdmission = getState().admission.admission;
                    if (currentAdmission && (currentAdmission.id === admission.id)) {
                        console.log('[action/admissions] resendSms fast reload');
                        dispatch({type: actionTypes.ADMISSION_SET, admission: response.data.admission});
                    }
                    dispatch({type: actionTypes.ADMISSION_UPDATE, admission: response.data.admission});
                } else {
                    addToast(`Failed to archive Admission Documents for admission ${admission.label} - ${response.data.error}`, {
                        appearance: 'error',
                        autoDismiss: false
                    });
                    dispatch({type: actionTypes.ARCHIVE_ADMISSION_DOCUMENTS_DONE, id: admission.id});
                }
            });
    }
}
export const archiveAdmissionDocuments2_init = (admission, addToast) => {
    return (dispatch, getState) => {
        console.log('[action/admissions] archiveAdmissionDocuments2_init', admission.id);
        const idToken = getState().auth.idToken;
        dispatch({type: actionTypes.LOADING_START});

        axios.get(
            `/admission/${admission.id}/archive-admission-documents2/init`,
            {headers: {'Authorization': idToken}}
        )
            .then((response) => {
                console.log('[action/admissions] archiveAdmissionDocuments2_init response', response.data);
                dispatch({type: actionTypes.LOADING_DONE});

                if (response.data.done) {
                    dispatch({type: actionTypes.MODAL_ARCHIVE_ADMISSION_DOCUMENTS2_SHOW, admission, config: response.data.config, admissionDocumentTypesWithoutSet: response.data.admissionDocumentTypesWithoutSet});
                } else {
                    addToast(`Cant archive Admission Documents for admission ${admission.label} - ${response.data.error}`, {
                        appearance: 'error',
                        autoDismiss: false
                    });
                    dispatch({type: actionTypes.ARCHIVE_ADMISSION_DOCUMENTS_DONE, id: admission.id});
                }
            });
    }
}

export const archiveAdmissionDocuments2 = (admission, addToast, skip, documentTypes) => {
    return (dispatch, getState) => {
        console.log('[action/admissions] archiveAdmissionDocuments2', admission.id, documentTypes);
        const idToken = getState().auth.idToken;
        dispatch({type: actionTypes.ARCHIVE_ADMISSION_DOCUMENTS_START, id: admission.id});
        dispatch({type: actionTypes.MODAL_ARCHIVE_ADMISSION_DOCUMENTS2_HIDE});

        axios.post(
            `/admission/${admission.id}/archive-admission-documents2`,
            {skip, documentTypes},
            {headers: {'Authorization': idToken}}
        )
            .then((response) => {
                console.log('[action/admissions] archiveAdmissionDocuments2 response', response.data);
                // dispatch({type: actionTypes.ADMISSION_SET, admission: response.data.admission});
                // dispatch({type: actionTypes.LOADING_DONE});
                if (response.data.done) {
                    addToast(`Admission Documents Archived for admission ${admission.label}`, {
                        appearance: 'success',
                        autoDismiss: false
                    });
                    dispatch({type: actionTypes.ARCHIVE_ADMISSION_DOCUMENTS_DONE, id: admission.id});
                    const currentAdmission = getState().admission.admission;
                    if (currentAdmission && (currentAdmission.id === admission.id)) {
                        console.log('[action/admissions] resendSms fast reload');
                        dispatch({type: actionTypes.ADMISSION_SET, admission: response.data.admission});
                    }
                    dispatch({type: actionTypes.ADMISSION_UPDATE, admission: response.data.admission});
                } else {
                    addToast(`Failed to archive Admission Documents for admission ${admission.label} - ${response.data.error}`, {
                        appearance: 'error',
                        autoDismiss: false
                    });
                    dispatch({type: actionTypes.ARCHIVE_ADMISSION_DOCUMENTS_DONE, id: admission.id});
                }
            });
    }
}


export const archivePatient = (admission, addToast) => {
    return (dispatch, getState) => {
        console.log('[action/admissions] archivePatient', admission.id);
        const idToken = getState().auth.idToken;
        dispatch({type: actionTypes.RELOADING_PROGRESS_START, id: admission.id});
        dispatch({type: actionTypes.MODAL_ARCHIVE_PATIENT_HIDE});

        axios.get(
            `/admission/${admission.id}/archive-patient`,
            {headers: {'Authorization': idToken}}
        )
            .then((response) => {
                console.log('[action/admissions] archivePatient response', response.data);
                dispatch({type: actionTypes.RELOADING_PROGRESS_DONE, id: admission.id});

                if (response.data.done) {
                    addToast(`Archived Patient ${admission.label}`, {
                        appearance: 'success',
                        autoDismiss: false
                    });
                    window.location.reload();
                } else {
                    addToast(`Failed to archive Patient - ${admission.label} - ${response.data.error}`, {
                        appearance: 'error',
                        autoDismiss: false
                    });
                }
            });
    }
}

export const archiveLifehousePdf = (admission, addToast) => {
    return (dispatch, getState) => {
        console.log('[action/admissions] archiveLifehousePdf', admission.id);
        const idToken = getState().auth.idToken;
        dispatch({type: actionTypes.RELOADING_PROGRESS_START, id: admission.id});
        dispatch({type: actionTypes.MODAL_ARCHIVE_CUSTOM_PDF_HIDE});

        axios.get(
            `/admission/${admission.id}/archive-lifehouse-pdf`,
            {headers: {'Authorization': idToken}}
        )
            .then((response) => {
                console.log('[action/admissions] archiveLifehousePdf response', response.data);

                if (response.data.done) {
                    addToast(`Uploaded paper docs Archived for admission ${admission.label}`, {
                        appearance: 'success',
                        autoDismiss: false
                    });
                    dispatch({type: actionTypes.RELOADING_PROGRESS_DONE, id: admission.id});
                    const currentAdmission = getState().admission.admission;
                    if (currentAdmission && (currentAdmission.id === admission.id)) {
                        console.log('[action/admissions] archiveLifehousePdf fast reload');
                        dispatch({type: actionTypes.ADMISSION_SET, admission: response.data.admission});
                    }
                    dispatch({type: actionTypes.ADMISSION_UPDATE, admission: response.data.admission});
                } else {
                    addToast(`Failed to archive paper docs for admission ${admission.label} - ${response.data.error}`, {
                        appearance: 'error',
                        autoDismiss: false
                    });
                    dispatch({type: actionTypes.RELOADING_PROGRESS_DONE, id: admission.id});
                }
            });
    }
}


export const sendManagerCustomUi = (admission, addToast, managerCustomUi) => {
// ======================================================
    return (dispatch, getState) => {
        console.log('[action/admissions] sendManagerCustomUi', admission.id);
        const idToken = getState().auth.idToken;
        dispatch({type: actionTypes.RELOADING_CUSTOM_COLUMN_START, id: admission.id});

        axios.post(
            `/admission/${admission.id}/send-manager-custom-ui/${managerCustomUi.id}`,
            {},
            {headers: {'Authorization': idToken}}
        )
            .then((response) => {
                dispatch({type: actionTypes.RELOADING_CUSTOM_COLUMN_DONE, id: admission.id});
                dispatch({type: actionTypes.ADMISSION_UPDATE, admission: response.data.admission});
            });
    }
}

export const sendAdmissionDocument = (admission, addToast, admissionDocumentType, smsNotification) => {
    return (dispatch, getState) => {
        console.log('[action/admissions] sendAdmissionDocument', admission.id, admissionDocumentType);
        const idToken = getState().auth.idToken;
        // dispatch({type: actionTypes.SEND_MESSAGE_START, id: admission.id});

        axios.post(
            `/admission/${admission.id}/send-admission-document`,
            {admissionDocumentType, smsNotification},
            {headers: {'Authorization': idToken}}
        )
            .then((response) => {
                console.log('[action/admissions] sendAdmissionDocument response', response.data);
                // dispatch({type: actionTypes.ADMISSION_SET, admission: response.data.admission});
                // dispatch({type: actionTypes.LOADING_DONE});
                if (response.data.done) {
                    addToast(`Form sent for admission ${admission.label}`, {
                        appearance: 'success',
                        autoDismiss: false
                    });
                    // dispatch({type: actionTypes.SEND_MESSAGE_DONE, id: admission.id});
                    const currentAdmission = getState().admission.admission;
                    if (currentAdmission && (currentAdmission.id === admission.id)) {
                        console.log('[action/admissions] sendAdmissionDocument fast reload');
                        dispatch({type: actionTypes.ADMISSION_SET, admission: response.data.admission});
                    }
                    dispatch({type: actionTypes.ADMISSION_UPDATE, admission: response.data.admission});
                } else {
                    addToast(`Failed to send Form for admission ${admission.label} - got exception ${response.data.customStatus}`, {
                        appearance: 'error',
                        autoDismiss: false
                    });
                    // dispatch({type: actionTypes.SEND_MESSAGE_DONE, id: admission.id});
                }
            });
    }
}

export const ignoreComment = (commentId, admissionId, commentsType, modalHeader, printEnable, managerStatuses, ignoreCommentEnable, addToast) => {
    return (dispatch, getState) => {
        dispatch({type: actionTypes.RELOADING_PROGRESS_START, id: admissionId});

        const idToken = getState().auth.idToken;

        console.log('[actions/admission] ignoreComment', admissionId, commentId);
        dispatch({type: actionTypes.MODAL_COMMENTS_HIDE});

        axios.get(
            `${process.env.REACT_APP_API_PATH}/admission/${admissionId}/ignore-comment/${commentId}`,
            {headers: {'Authorization': idToken}}
        )
            .then((response) => {
                console.log('[actions/admission] ignoreComment reload admissions list');
                dispatch({type: actionTypes.RELOADING_PROGRESS_DONE, id: admissionId});
                dispatch({type: actionTypes.ADMISSION_UPDATE, admission: response.data.admission});
                dispatch({
                    type: actionTypes.MODAL_COMMENTS_SHOW,
                    admission: response.data.admission,
                    commentsType,
                    modalHeader,
                    printEnable,
                    managerStatuses,
                    ignoreCommentEnable,
                });
                addToast(`Comment ignored`, {appearance: 'success', autoDismiss: true});
            });
    }
}

export const addComment = (admission, body, commentsType, status, addToast) => {
    return (dispatch, getState) => {
        dispatch({type: actionTypes.RELOADING_PROGRESS_START, id: admission.id});

        const idToken = getState().auth.idToken;

        console.log('[actions/admission] addComment', admission.id);
        dispatch({type: actionTypes.MODAL_COMMENTS_HIDE});

        axios.post(
            `${process.env.REACT_APP_API_PATH}/admission/${admission.id}/add-comment`,
            {body, status, commentsType},
            {headers: {'Authorization': idToken}}
        )
            .then((response) => {
                console.log('[actions/admission] addComment reload admissions list');
                dispatch({type: actionTypes.RELOADING_PROGRESS_DONE, id: admission.id});
                dispatch({type: actionTypes.ADMISSION_UPDATE, admission: response.data.admission});
                addToast(`Comment added for ${admission.label}`, {
                    appearance: 'success',
                    autoDismiss: true
                });
            });
    }
}

export const sendLifehouseReminder = (admission, addToast) => {
    return (dispatch, getState) => {
        console.log('[action/admissions] sendLifehouseReminder', admission.id);
        const idToken = getState().auth.idToken;
        dispatch({type: actionTypes.RELOADING_PROGRESS_START, id: admission.id});

        return axios.post(
            `/admission/${admission.id}/lifehouse-reminder`,
            {},
            {headers: {'Authorization': idToken}}
        )
        .then((response) => {
            console.log('[action/admissions] sendLifehouseReminder response', response.data);
            dispatch({type: actionTypes.RELOADING_PROGRESS_DONE, id: admission.id});

            if (response.data.done) {
                addToast('Lifehouse admission reminder sent successfully', {
                    appearance: 'success',
                    autoDismiss: true
                });
                const currentAdmission = getState().admission.admission;
                if (currentAdmission && (currentAdmission.id === admission.id)) {
                    console.log('[action/admissions] sendLifehouseReminder fast reload');
                    dispatch({type: actionTypes.ADMISSION_SET, admission: response.data.admission});
                }
                dispatch({type: actionTypes.ADMISSION_UPDATE, admission: response.data.admission});
            } else {
                addToast('Failed to send Lifehouse admission reminder', {
                    appearance: 'error',
                    autoDismiss: true
                });
            }
            return response;
        })
        .catch(error => {
            dispatch({type: actionTypes.RELOADING_PROGRESS_DONE, id: admission.id});
            addToast('Failed to send Lifehouse admission reminder', {
                appearance: 'error',
                autoDismiss: true
            });
            console.error('Error sending Lifehouse reminder:', error);
            throw error; // Re-throw to propagate to the component
        });
    }
}

export const toggleSmsOptOut = (admission, addToast) => {
    return (dispatch, getState) => {
        console.log('[action/admissions] toggleSmsOptOut', admission.id);
        const idToken = getState().auth.idToken;
        dispatch({type: actionTypes.TOGGLE_SMS_OPT_OUT_START, id: admission.id});
        
        return axios.get(
            `/admission/${admission.id}/toggle-sms-opt-out`,
            {headers: {'Authorization': idToken}}
        )
        .then((response) => {
            console.log('[action/admissions] toggleSmsOptOut response', response.data);
            
            if (response.data.done) {
                const statusText = response.data.isSmsOptOut ? 'opted out of' : 'opted in to';
                addToast(`Patient has been ${statusText} SMS messages`, {
                    appearance: 'success',
                    autoDismiss: true
                });
                
                const currentAdmission = getState().admission.admission;
                if (currentAdmission && (currentAdmission.id === admission.id)) {
                    console.log('[action/admissions] toggleSmsOptOut fast reload');
                    dispatch({type: actionTypes.ADMISSION_SET, admission: response.data.admission});
                }
                dispatch({type: actionTypes.ADMISSION_UPDATE, admission: response.data.admission});
            } else {
                addToast('Failed to toggle SMS opt-out status', {
                    appearance: 'error',
                    autoDismiss: true
                });
            }
            dispatch({type: actionTypes.TOGGLE_SMS_OPT_OUT_DONE, id: admission.id});
            return response;
        })
        .catch(error => {
            dispatch({type: actionTypes.TOGGLE_SMS_OPT_OUT_DONE, id: admission.id});
            addToast('Failed to toggle SMS opt-out status', {
                appearance: 'error',
                autoDismiss: true
            });
            console.error('Error toggling SMS opt-out:', error);
            throw error;
        });
    }
}

export const sendDischargeSurvey = (admission, addToast) => {
    return (dispatch, getState) => {
        console.log('[action/admissions] sendDischargeSurvey', admission.id);
        const idToken = getState().auth.idToken;
        dispatch({type: actionTypes.SEND_DISCHARGE_SURVEY_START, id: admission.id});

        return axios.post(
            `/admission/${admission.id}/send-survey`,
            {},
            {headers: {'Authorization': idToken}}
        )
        .then((response) => {
            console.log('[action/admissions] sendDischargeSurvey response', response.data);

            if (response.data.done) {
                addToast('Discharge survey has been sent', {appearance: 'success', autoDismiss: true});

                const currentAdmission = getState().admission.admission;
                if (currentAdmission && (currentAdmission.id === admission.id)) {
                    dispatch({type: actionTypes.ADMISSION_SET, admission: response.data.admission});
                }
                dispatch({type: actionTypes.ADMISSION_UPDATE, admission: response.data.admission});
            } else {
                addToast(response.data.error || 'Failed to send discharge survey', {appearance: 'error', autoDismiss: true});
            }
            dispatch({type: actionTypes.SEND_DISCHARGE_SURVEY_DONE, id: admission.id});
            return response;
        })
        .catch(error => {
            dispatch({type: actionTypes.SEND_DISCHARGE_SURVEY_DONE, id: admission.id});
            const message = error?.response?.data?.error || 'Failed to send discharge survey';
            addToast(message, {appearance: 'error', autoDismiss: true});
            console.error('Error sending discharge survey:', error);
            throw error;
        });
    }
}

export const toggleExternalFinDoc = (admission, addToast) => {
    return (dispatch, getState) => {
        const idToken = getState().auth.idToken;
        dispatch({type: actionTypes.TOGGLE_EXTERNAL_COMPLETION_START, id: admission.id});

        return axios.get(
            `/admission/${admission.id}/toggle-external-fin-doc-completed`,
            {headers: {'Authorization': idToken}}
        )
        .then((response) => {
            if (response.data.done) {
                addToast('External financial documents completion toggled', {appearance: 'success', autoDismiss: true});
                const currentAdmission = getState().admission.admission;
                if (currentAdmission && (currentAdmission.id === admission.id)) {
                    dispatch({type: actionTypes.ADMISSION_SET, admission: response.data.admission});
                }
                dispatch({type: actionTypes.ADMISSION_UPDATE, admission: response.data.admission});
            } else {
                addToast('Failed to toggle external completion', {appearance: 'error', autoDismiss: true});
            }
            dispatch({type: actionTypes.TOGGLE_EXTERNAL_COMPLETION_DONE, id: admission.id});
        })
        .catch(error => {
            dispatch({type: actionTypes.TOGGLE_EXTERNAL_COMPLETION_DONE, id: admission.id});
            addToast('Failed to toggle external completion', {appearance: 'error', autoDismiss: true});
        });
    }
}

export const toggleExternalPayment = (admission, addToast) => {
    return (dispatch, getState) => {
        const idToken = getState().auth.idToken;
        dispatch({type: actionTypes.TOGGLE_EXTERNAL_COMPLETION_START, id: admission.id});

        return axios.get(
            `/admission/${admission.id}/toggle-external-payment-completed`,
            {headers: {'Authorization': idToken}}
        )
        .then((response) => {
            if (response.data.done) {
                addToast('External payment completion toggled', {appearance: 'success', autoDismiss: true});
                const currentAdmission = getState().admission.admission;
                if (currentAdmission && (currentAdmission.id === admission.id)) {
                    dispatch({type: actionTypes.ADMISSION_SET, admission: response.data.admission});
                }
                dispatch({type: actionTypes.ADMISSION_UPDATE, admission: response.data.admission});
            } else {
                addToast('Failed to toggle external payment completion', {appearance: 'error', autoDismiss: true});
            }
            dispatch({type: actionTypes.TOGGLE_EXTERNAL_COMPLETION_DONE, id: admission.id});
        })
        .catch(error => {
            dispatch({type: actionTypes.TOGGLE_EXTERNAL_COMPLETION_DONE, id: admission.id});
            addToast('Failed to toggle external payment completion', {appearance: 'error', autoDismiss: true});
        });
    }
}

export const checkCopyPreAddData = (admission) => {
    return (dispatch, getState) => {
        console.log('[action/admissions] checkCopyPreAddData', admission.id);
        const idToken = getState().auth.idToken;
        dispatch({type: actionTypes.RELOADING_PROGRESS_START, id: admission.id});
        
        return axios.get(
            `/admission/${admission.id}/copy-pre-add-data`,
            {headers: {'Authorization': idToken}}
        )
        .then((response) => {
            console.log('[action/admissions] checkCopyPreAddData response', response.data);
            dispatch({type: actionTypes.RELOADING_PROGRESS_DONE, id: admission.id});
            
            if (response.data.available) {
                dispatch({
                    type: actionTypes.MODAL_CONFIRM_ADMISSION_ACTION_SHOW,
                    admission: admission,
                    actionLabel: response.data.msg,
                    documentTypesToCopy: response.data.documentTypesToCopy || [],
                    isCopyPreAddData: true,
                    actionDispatchable: null
                });
            } else {
                dispatch({
                    type: actionTypes.MODAL_ERROR_SHOW, 
                    message: response.data.msg || "No suitable previous admissions found to copy data from."
                });
            }
            return response;
        })
        .catch(error => {
            dispatch({type: actionTypes.RELOADING_PROGRESS_DONE, id: admission.id});
            dispatch({
                type: actionTypes.MODAL_ERROR_SHOW, 
                message: "An error occurred while checking for previous admission data."
            });
            console.error('Error checking for previous admission data:', error);
            throw error;
        });
    }
}

export const executeCopyPreAddData = (admission, documentOptions = {}) => {
    return (dispatch, getState) => {
        console.log('[action/admissions] executeCopyPreAddData', admission.id, documentOptions);
        const idToken = getState().auth.idToken;
        dispatch({type: actionTypes.RELOADING_PROGRESS_START, id: admission.id});

        return axios.post(
            `/admission/${admission.id}/copy-pre-add-data`,
            {documentOptions},
            {headers: {'Authorization': idToken}}
        )
        .then((response) => {
            console.log('[action/admissions] executeCopyPreAddData response', response.data);
            
            if (response.data.success) {
                // Update UI with success message
                dispatch({
                    type: actionTypes.RELOADING_PROGRESS_DONE,
                    id: admission.id
                });
                
                // Reload admission if needed
                const currentAdmission = getState().admission.admission;
                if (currentAdmission && (currentAdmission.id === admission.id)) {
                    dispatch({type: actionTypes.ADMISSION_SET, admission: response.data.admission});
                }
                
                // Update in list if available
                if (response.data.admission) {
                    dispatch({type: actionTypes.ADMISSION_UPDATE, admission: response.data.admission});
                }
            } else {
                dispatch({
                    type: actionTypes.MODAL_ERROR_SHOW, 
                    message: response.data.msg || "Failed to copy pre-admission data"
                });
                dispatch({type: actionTypes.RELOADING_PROGRESS_DONE, id: admission.id});
            }
            return response;
        })
        .catch(error => {
            dispatch({type: actionTypes.RELOADING_PROGRESS_DONE, id: admission.id});
            dispatch({
                type: actionTypes.MODAL_ERROR_SHOW, 
                message: "An error occurred while copying pre-admission data."
            });
            console.error('Error copying pre-admission data:', error);
            throw error;
        });
    }
}

export const imp406Action = (admission, addToast) => {
    return (dispatch, getState) => {
        dispatch({type: actionTypes.RELOADING_START});
        const idToken = getState().auth.idToken;

        console.log('[actions/modal] imp406Action', admission.id);
        axios.post(
            `/admission/${admission.id}/imp-406`,
            {},
            {headers: {'Authorization': idToken}}
        )
            .then((response) => {
                console.log('[actions/modal] imp406Action response ', response.data);
                addToast('Admission status patched successfully', {
                    appearance: 'success',
                    autoDismiss: true
                });
                const currentAdmission = getState().admission.admission;
                if (currentAdmission && (currentAdmission.id === admission.id)) {
                    dispatch({type: actionTypes.ADMISSION_SET, admission: response.data.admission});
                }

                // Update in list if available
                if (response.data.admission) {
                    dispatch({type: actionTypes.ADMISSION_UPDATE, admission: response.data.admission});
                }
                dispatch({type: actionTypes.RELOADING_DONE});
            })
            .catch((error) => {
                console.error('[actions/modal] imp406Action error ', error);
                addToast('IMP-406 execution failed', {
                    appearance: 'error',
                    autoDismiss: true
                });
                dispatch({type: actionTypes.RELOADING_DONE});
            });
    }
}

export const demoMarkPaymentNotCompleted = (admission, addToast) => {
    return (dispatch, getState) => {
        dispatch({type: actionTypes.RELOADING_START});
        const idToken = getState().auth.idToken;

        console.log('[actions/admission] demoMarkPaymentNotCompleted', admission.id);
        axios.post(
            `/admission/${admission.id}/demo/mark-payment-not-completed`,
            {},
            {headers: {'Authorization': idToken}}
        )
            .then((response) => {
                console.log('[actions/admission] demoMarkPaymentNotCompleted response ', response.data);
                if (response.data.done) {
                    addToast('Payment marked as not completed', {
                        appearance: 'success',
                        autoDismiss: true
                    });
                    const currentAdmission = getState().admission.admission;
                    if (currentAdmission && (currentAdmission.id === admission.id)) {
                        dispatch({type: actionTypes.ADMISSION_SET, admission: response.data.admission});
                    }
                    dispatch({type: actionTypes.ADMISSION_UPDATE, admission: response.data.admission});
                } else {
                    addToast(response.data.error || 'Failed to mark payment as not completed', {
                        appearance: 'error',
                        autoDismiss: true
                    });
                }
                dispatch({type: actionTypes.RELOADING_DONE});
            })
            .catch((error) => {
                console.error('[actions/admission] demoMarkPaymentNotCompleted error ', error);
                addToast('Failed to mark payment as not completed', {
                    appearance: 'error',
                    autoDismiss: true
                });
                dispatch({type: actionTypes.RELOADING_DONE});
            });
    }
}
